import {
  createApp
} from 'vue'
import App from './App.vue'
import store from './store'
import "./style/index.scss"; // 全局引入样式
import "./style/animate.scss";
import 'vant/lib/index.css';
import router from "./router";
import './permission'
// import { Button } from 'vant';
import tree from '@/components/instructions/tree.vue'
import VueQr from 'vue-qr/src/packages/vue-qr.vue'

import {
  Empty,
  Divider,
  Field,
  Button,
  Tabbar,
  TabbarItem,
  Toast,
  Dialog,
  NavBar,
  Icon,
  Cell,
  CellGroup,
  Cascader,
  Popup,
  Popover,
  ActionSheet,
  Form,
  Tab,
  Tabs,
  Search,
  Swipe,
  SwipeItem,
  Image as VanImage,
  Uploader,
  List,
  Skeleton,
  Sidebar,
  SidebarItem,
  Overlay,
  Loading,
  Checkbox,
  CheckboxGroup,
  Step,
  Steps,
  Collapse,
  Progress,
  CollapseItem,
  DropdownMenu,
  DropdownItem,
  Grid,
  GridItem,
  AddressList,
  AddressEdit,
  Switch,
  Area,
  RadioGroup,
  Radio,
  DatetimePicker,

} from 'vant';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
import VueHashCalendar from 'vue3-hash-calendar';
import 'vue3-hash-calendar/es/index.css';
// 注册组件库
import VuewechatTitle from 'vue-wechat-title'
const app = createApp(App);
app.component('Tree', tree)
app.component('VueQr', VueQr)
app.use(Step);
app.use(Steps);
app.use(VueHashCalendar)
app.use(CheckboxGroup)
app.use(Checkbox)
// app.use(vConsole)
app.use(Collapse);
app.use(Progress);
app.use(CollapseItem);
app.use(Loading);
app.use(Overlay);
app.use(Sidebar);
app.use(SidebarItem);
app.use(Skeleton);
app.use(List);
app.use(Uploader);
app.use(Form);
app.use(Icon);
app.use(Divider);
app.use(NavBar);
app.use(Field);
app.use(Button);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Tab);
app.use(Cell);
app.use(CellGroup);
app.use(Toast);
app.use(Dialog);
app.use(Cascader);
app.use(Popup);
app.use(Popover);
app.use(ActionSheet);
app.use(Empty);
app.use(Tab);
app.use(Tabs);
app.use(Search);
app.use(Swipe);
app.use(SwipeItem);
app.use(VanImage);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Grid);
app.use(GridItem);
app.use(AddressList);
app.use(AddressEdit);
app.use(Switch);
app.use(Area);
app.use(RadioGroup);
app.use(Radio);
app.use(DatetimePicker);

// mocks数据
// VUE_APP_MOCK的值为true，并且在开发环境下
// if (process.env.VUE_APP_MOCK && process.env.NODE_ENV === 'development') {
//   require("./mock");
// }
app.use(store)
app.use(router)
app.use(VuewechatTitle)
app.mount('#app')